import { isEmpty, isNil } from 'lodash';
import { BaseDrawOption } from '@/modules/ta/widget/models/drawoptions/BaseDrawOption';
import {
  WidgetPlotTypeOptions as PlotType,
  SparkLineTypes,
  BigNumberWrapFormat,
  WidgetBackgroundGradientColorOptions,
  HorizontalAlignments,
  DrawOption,
  WidgetBackgroundColorOptions,
} from '@/modules/ta/widget/widget.constants';

export class BigNumberDrawOption extends BaseDrawOption {
  /**
   * @var {number}
   */
  font_size;

  /**
   * @var {number}
   */
  wrapped_font_size;

  /**
   * @var {number}
   */
  circle_font_size;

  /**
   * @var {number}
   */
  reduce_number;

  /**
   * @var {string}
   */
  center_numbers;

  /**
   * @var {boolean}
   */
  circle_number;

  /**
   * @var {number}
   */
  circle_size;

  /**
   * @var {boolean}
   */
  show_metric_name;

  /**
   * @var {boolean}
   */
  wrap_metric_name;

  /**
   * @var {boolean}
   */
  wrap_number;

  /**
   * @var {boolean}
   */
  border_width;

  /**
   * @var {string}
   */
  border_color;

  /**
   * @var {object}
   */
  font_properties;

  /**
   * @var {string}
   */
  background_color_type;

  /**
   * @var {string}
   */
  background_gradient;

  /**
   * @var {string}
   */
  gradient_color;

  /**
   * @var {string}
   */
  background_color;

  /**
   * @var {number}
   */
  corner_radius;

  /**
   * @var {string}
   */
  plot_type;

  /**
   * @var {string}
   */
  sparkline_type;

  /**
   * @var {boolean}
   */
  spacing_toggle;

  /**
   * @var {number}
   */
  spacing;

  constructor(model = {}) {
    super(model);

    this.setValidPlotType(model);

    let { circle_number, wrap_number } = model;

    if (circle_number === true) {
      circle_number = BigNumberWrapFormat.CIRCLE;
      wrap_number = true;
    } else if (circle_number === false) {
      circle_number = BigNumberWrapFormat.SQUARE;
    }

    this.font_size = model.font_size || 30;
    this.circle_font_size = model.circle_font_size || 22;
    this.reduce_number = isNil(model.reduce_number) ? true : model.reduce_number;
    this.center_numbers = model.center_numbers ?? HorizontalAlignments.CENTER;
    this.circle_number = circle_number ?? BigNumberWrapFormat.SQUARE;
    this.wrapped_font_size = model.wrapped_font_size || DrawOption.STATIC_FONT_SIZE;
    this.circle_size = isNil(model.circle_size) ? DrawOption.STATIC_CIRCLE_SIZE : model.circle_size;
    const rawShowMetricName = model.show_metric_name;
    this.show_metric_name = isNil(rawShowMetricName)
      ? { value: true, overridden: false }
      : rawShowMetricName;
    this.wrap_metric_name = isNil(model.wrap_metric_name) ? true : model.wrap_metric_name;
    this.wrap_number = isNil(wrap_number) ? false : wrap_number;
    this.border_width = isNil(model.border_width) ? 0 : model.border_width;
    this.border_color = isNil(model.border_color) ? null : model.border_color;
    this.font_properties =
      isNil(model.font_properties) || isEmpty(model.font_properties)
        ? {
            bold: false,
            italic: false,
            underline: false,
            strikethrough: false,
            text_color: null,
          }
        : model.font_properties;
    this.background_color_type = isNil(model.background_color_type)
      ? WidgetBackgroundColorOptions.THEME
      : model.background_color_type;
    this.background_gradient = isNil(model.background_gradient)
      ? WidgetBackgroundGradientColorOptions.SOLID
      : model.background_gradient;
    this.gradient_color = isNil(model.gradient_color) ? null : model.gradient_color;
    this.background_color = isNil(model.background_color) ? null : model.background_color;
    this.corner_radius = isNil(model.corner_radius) ? 0 : model.corner_radius;
    this.sparkline_type = model.sparkline_type || SparkLineTypes.LINE;
    this.spacing = isNil(model.spacing) ? 15 : model.spacing;
    this.spacing_toggle = isNil(model.spacing_toggle) ? false : model.spacing_toggle;
  }

  setValidPlotType(model) {
    const validTypes = [
      PlotType.DEFAULT,
      PlotType.MULTI_METRIC,
      PlotType.COMPARISON,
      PlotType.SPARKLINE,
      PlotType.CLASSIC,
    ];

    if (!model.plot_type || !validTypes.includes(model.plot_type)) {
      this.plot_type = PlotType.DEFAULT;
    } else {
      this.plot_type = model.plot_type;
    }
  }
}
